import moment from 'moment';
import { LitElement } from '~/lib/bn-lit-element';
import { css, html, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class ImportPreview extends LitElement {
  static get properties() {
    return {
      recordPreview: { type: Object },
      mapping: { type: Object },
      importPreviewRenderer: { type: Function },
      showUsage: { type: Boolean, attribute: 'show-usage' },
      lastImportedAt: { type: String, attribute: 'last-imported-at' },
      createdAt: { type: String, attribute: 'created-at' },
      lastImportName: { type: String, attribute: 'last-import-name' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .properties {
        display: flex;
        flex-wrap: wrap;
      }

      .properties + .properties {
        margin-top: 0.5em;
      }

      bn-property {
        margin: 0 2em 0 0;
      }
    `];
  }

  render() {
    if (!this.recordPreview || !this.mapping) {
      return html``;
    }

    return html`
      ${renderIf(this.showUsage, html`
        <div class="properties">
          <div>
            ${renderIf(!this.lastImportedAt, html`
              <span><b>Never used</b>, created at <b>${this._formatDate(this.createdAt)}</b></span>
            `)}
            ${renderIf(this.lastImportedAt, html`
              <label>Last used with</label>
              <div><b>${this.lastImportName || 'Import'}</b> at <b>${this._formatDate(this.lastImportedAt)}</b></div>
            `)}
          </div>
        </div>
      `)}
      ${(this.importPreviewRenderer({ mapping: this.mapping, recordPreview: this.recordPreview }))}
    `;
  }

  _formatDate(date) {
    return moment(date).format('MMMM D, YYYY h:mm a');
  }
}

window.customElements.define('import-preview', ImportPreview);
